import { useEffect, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5, H7 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { GET_WEBHOOK_DATA } from 'automation-ui-enrollment/queries/WebhookQueries';
import UIButton from 'UIComponents/button/UIButton';
import WebhookPayloadContainer from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookPayloadContainer';
import HR from 'UIComponents/elements/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WEBHOOK_POLL_INTERVAL = 500;
const WebhookPollingContainer = ({
  callbackId,
  refetchUrl,
  handleDataReceived,
  hasExistingWebhookData,
  setDisableNext
}) => {
  const [showPayload, setShowPayload] = useState(hasExistingWebhookData);
  const {
    stopPolling,
    error,
    data
  } = useQuery(GET_WEBHOOK_DATA, {
    variables: {
      callbackId
    },
    pollInterval: WEBHOOK_POLL_INTERVAL
  });
  useEffect(() => {
    if (!error && !hasExistingWebhookData && data && data.webhookData.webhookData) {
      stopPolling();
      handleDataReceived(data.webhookData.webhookData, data.webhookData.id);
    }
  }, [error, data, stopPolling, hasExistingWebhookData, handleDataReceived]);
  if (error) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.connectingApp.pollingError.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.connectingApp.pollingError.description"
      })
    });
  }
  if (!data || !data.webhookData.webhookData) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      justify: "center",
      align: "center",
      children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      }), /*#__PURE__*/_jsx(H7, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.dataLoading.title"
        })
      })]
    });
  }
  if (Object.keys(data.webhookData.webhookData.response).length === 0) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      justify: "center",
      align: "center",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "remove",
        size: "xs",
        color: CANDY_APPLE,
        className: "m-all-2"
      }), /*#__PURE__*/_jsx(H7, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.missingProperties.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.connectingApp.missingProperties.description"
      }), /*#__PURE__*/_jsx(UIFlex, {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: refetchUrl,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.missingProperties.retryButton"
          })
        })
      }), /*#__PURE__*/_jsxs(WebhookPayloadContainer, {
        webhookData: data.webhookData.webhookData,
        children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(H5, {
          className: "align-self-start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.missingProperties.header"
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsx(UIFlex, {
    direction: "column",
    justify: "center",
    align: "center",
    children: !showPayload ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
        showResult: true,
        onResultDisplayFinish: () => {
          setShowPayload(true);
          setDisableNext(false);
        }
      }), /*#__PURE__*/_jsx(H7, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.dataSuccess.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.connectingApp.dataSuccess.description"
      })]
    }) : /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "start",
      children: [/*#__PURE__*/_jsxs(WebhookPayloadContainer, {
        webhookData: data.webhookData.webhookData,
        children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(H5, {
          className: "align-self-start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.dataSuccess.header"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.dataSuccess.reviewDescription"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-y-2",
          message: "automation-ui-enrollment.webhookWizard.connectingApp.dataSuccess.secondReviewDescription"
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-2",
        use: "transparent",
        onClick: () => {
          refetchUrl();
          setShowPayload(false);
        },
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.missingProperties.retryButton"
        })
      })]
    })
  });
};
export default WebhookPollingContainer;